import React from "react";
import { Route } from "react-router-dom";
import { OrganizationCard } from "./OrganizationCard";
import { OrganizationUIProvider } from "./OrganizationUIContext";
import { PrivateRoute } from "../../../../PrivateRoute";
import { RoleChecker } from "../../../../RoleChecker";
import { OrganizationDetail } from "./organization-detail/OrganizationDetail";

export function OrganizationPage({ history, match }) {
  const organizationUIEvents = {
    newOrganizationButtonClick: () => {
      history.push("/admin/organization/-/new");
    },
    openEditOrganizationPage: id => {
      history.push(`/admin/organization/${id}/edit`);
    },
    openOrganizationFilePage: id => {
      history.push(`/admin/organization/file/${id}`);
    }
  };
  return (
    <OrganizationUIProvider organizationUIEvents={organizationUIEvents}>
      <OrganizationCard match={match} />
    </OrganizationUIProvider>
  );
}
